import { parseApiResponseErrors } from '@js/parse-api-errors';

export default {
	/**
	 * Add as a vue plugin, enables this object to be passed in Vue.use()
	 * @param  {Object} Vue
	 */
	install(Vue) {
		// eslint-disable-next-line no-param-reassign
		Vue.prototype.$ErrorHandler = {
			reportError: this.reportError,
			parseResponseError: this.parseResponseError,
		};
	},

	/**
	 * Report an error
	 * @param  {String} message - The message to report
	 * @param  {Object} error   - An object with debugging information
	 */
	reportError(message, error) {
		window.console.error(message, error);
	},

	/**
	 * Parse a response error
	 * @param  {Error}  error          - The error instance to parse
	 * @param  {String} defaultMessage - The default error message
	 * @return {Array}                 - A list of error messages
	 */
	parseResponseError(error, defaultMessage) {
		const messages = parseApiResponseErrors(error, defaultMessage);

		if (messages === null) {
			this.reportError('Invalid server response!', error);
			return [defaultMessage];
		}

		return messages;
	},
};
